import React, { useState } from 'react';

const QRCodeForm = ({ onGenerate }) => {
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        onGenerate(value); // Automatically generate the QR code as the user types
    };

    return (
        <div className="flex flex-col items-center mt-2">
            <h1 className='mb-6 text-3xl'>Get Free QR Code Here</h1>
            <input
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder="Enter text or URL"
                className="border border-gray-300 rounded w-full p-2 text-center"
                style={{ fontSize: '1.25rem' }}
            />
        </div>
    );
};

export default QRCodeForm;
